'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactackleCore = require('reactackle-core');

var _reactackleIcons = require('reactackle-icons');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var constants = {
  themeColor: _reactackleCore.colorSecondary,
  fontColor: _reactackleCore.bodyFontColor,
  backgroundColor: _reactackleCore.colorTransparent,
  borderStyle: 'solid',

  size: {
    paddingY: (0, _reactackleCore.bmodule)(1),
    paddingX: (0, _reactackleCore.bmodule)(1),
    fontSize: _reactackleCore.fontSizeBody,
    lineHeight: 1.5, // Only number accepted

    dense: {
      paddingY: (0, _reactackleCore.bmodule)(0.5),
      paddingX: (0, _reactackleCore.bmodule)(0.5),
      fontSize: _reactackleCore.fontSizeBody,
      lineHeight: 1.5 // Only number accepted
    },

    fullWidth: {
      paddingY: (0, _reactackleCore.bmodule)(1.5),
      paddingX: (0, _reactackleCore.bmodule)(1.5),
      fontSize: _reactackleCore.fontSizeBody,
      lineHeight: 1.5 // Only number accepted
    },

    denseFullWidth: {
      paddingY: (0, _reactackleCore.bmodule)(1),
      paddingX: (0, _reactackleCore.bmodule)(1),
      fontSize: _reactackleCore.fontSizeBody,
      lineHeight: 1.5 // Only number accepted
    }
  },

  underlined: {
    paddingY: (0, _reactackleCore.bmodule)(1)
  },

  iconOuter: {
    opacity: 0.54
  },

  iconInner: {
    opacity: 0.46
  }
};

exports.default = {
  selectBox: {
    themeColor: constants.themeColor,
    placeholderFontColor: _reactackleCore.fontColorMedium,
    minWidth: 120,

    style: {
      fontColor: constants.fontColor,
      backgroundColor: constants.backgroundColor,
      borderColor: _reactackleCore.colorPaletteGrey300,
      borderStyle: constants.borderStyle,

      hover: {
        fontColor: constants.fontColor,
        backgroundColor: 'rgba(0,0,0,0.03)',
        borderColor: constants.themeColor,
        borderStyle: constants.borderStyle
      },

      focus: {
        fontColor: constants.fontColor,
        backgroundColor: _reactackleCore.colorWhite,
        borderColor: constants.themeColor,
        borderStyle: constants.borderStyle
      },

      disabled: {
        fontColor: _reactackleCore.fontColorMedium,
        backgroundColor: _reactackleCore.colorTransparent,
        borderColor: _reactackleCore.colorPaletteGrey300,
        borderStyle: 'dotted'
      },

      error: {
        fontColor: _reactackleCore.colorError,
        backgroundColor: constants.backgroundColor,
        borderColor: _reactackleCore.colorError,
        borderStyle: constants.borderStyle,

        hover: {
          fontColor: _reactackleCore.colorError,
          backgroundColor: 'rgba(0,0,0,0.03)',
          borderColor: _reactackleCore.colorError,
          borderStyle: constants.borderStyle
        },

        focus: {
          fontColor: _reactackleCore.colorError,
          backgroundColor: 'rgba(0,0,0,0.03)',
          borderColor: _reactackleCore.colorError,
          borderStyle: constants.borderStyle
        }
      },

      success: {
        fontColor: constants.fontColor,
        backgroundColor: constants.backgroundColor,
        borderColor: _reactackleCore.colorSuccess,
        borderStyle: constants.borderStyle,

        hover: {
          fontColor: constants.fontColor,
          backgroundColor: 'rgba(0,0,0,0.03)',
          borderColor: _reactackleCore.colorSuccess,
          borderStyle: constants.borderStyle
        },

        focus: {
          fontColor: constants.fontColor,
          backgroundColor: 'rgba(0,0,0,0.03)',
          borderColor: _reactackleCore.colorSuccess,
          borderStyle: constants.borderStyle
        }
      }
    },

    bordered: {
      borderWidth: 1,
      borderRadius: _reactackleCore.radiusDefault,

      size: {
        paddingY: constants.size.paddingY,
        paddingX: constants.size.paddingX,
        lineHeight: constants.size.lineHeight,
        fontSize: constants.size.fontSize,

        dense: {
          paddingY: constants.size.dense.paddingY,
          paddingX: constants.size.dense.paddingX,
          lineHeight: constants.size.lineHeight,
          fontSize: constants.size.dense.fontSize
        },

        fullWidth: {
          paddingY: constants.size.fullWidth.paddingY,
          paddingX: constants.size.fullWidth.paddingX,
          lineHeight: constants.size.lineHeight,
          fontSize: constants.size.fullWidth.fontSize
        },

        denseFullWidth: {
          paddingY: constants.size.denseFullWidth.paddingY,
          paddingX: constants.size.denseFullWidth.paddingX,
          lineHeight: constants.size.lineHeight,
          fontSize: constants.size.denseFullWidth.fontSize
        }
      }
    },

    underlined: {
      borderWidth: 2,
      borderRadius: 0,

      size: {
        paddingY: constants.size.paddingY,
        paddingX: 0,
        lineHeight: constants.size.lineHeight,
        fontSize: constants.size.fontSize,

        dense: {
          paddingY: constants.size.dense.paddingY,
          paddingX: 0,
          lineHeight: constants.size.lineHeight,
          fontSize: constants.size.dense.fontSize
        },

        fullWidth: {
          paddingY: constants.size.fullWidth.paddingY,
          paddingX: 0,
          lineHeight: constants.size.lineHeight,
          fontSize: constants.size.fullWidth.fontSize
        },

        denseFullWidth: {
          paddingY: constants.size.denseFullWidth.paddingY,
          paddingX: 0,
          lineHeight: constants.size.lineHeight,
          fontSize: constants.size.denseFullWidth.fontSize
        }
      }
    }
  },

  label: {
    positionTop: {
      fontSize: _reactackleCore.fontSizeSmall,
      lineHeight: 1,
      textTransform: 'none',
      fontWeight: _reactackleCore.fontWeightNormal,

      style: {
        fontColor: _reactackleCore.fontColorMedium,

        disabled: {
          fontColor: _reactackleCore.fontColorMedium
        },

        focus: {
          fontColor: constants.themeColor
        },

        error: {
          fontColor: _reactackleCore.colorError
        },

        success: {
          fontColor: _reactackleCore.colorSuccess
        }
      },

      size: {
        bordered: {
          labelSelectSpacing: (0, _reactackleCore.bmodule)(1),

          dense: {
            labelSelectSpacing: (0, _reactackleCore.bmodule)(0.5)
          },

          fullWidth: {
            labelSelectSpacing: (0, _reactackleCore.bmodule)(0.5)
          },

          denseFullWidth: {
            labelSelectSpacing: (0, _reactackleCore.bmodule)(0.5)
          }
        },

        underlined: {
          labelSelectSpacing: (0, _reactackleCore.bmodule)(0.5),

          dense: {
            labelSelectSpacing: (0, _reactackleCore.bmodule)(0.5)
          },

          fullWidth: {
            labelSelectSpacing: (0, _reactackleCore.bmodule)(0.5)
          },

          denseFullWidth: {
            labelSelectSpacing: (0, _reactackleCore.bmodule)(0.5)
          }
        }
      }
    },

    positionSide: {
      fontSize: _reactackleCore.fontSizeBody,
      lineHeight: _reactackleCore.bodyLineHeight,
      textTransform: 'none',
      fontWeight: _reactackleCore.fontWeightNormal,
      width: '30%',

      style: {
        fontColor: _reactackleCore.bodyFontColor,

        disabled: {
          fontColor: _reactackleCore.fontColorMedium
        },

        focus: {
          fontColor: constants.themeColor
        },

        error: {
          fontColor: _reactackleCore.colorError
        },

        success: {
          fontColor: _reactackleCore.colorSuccess
        }
      },

      size: {
        bordered: {
          labelSelectSpacing: (0, _reactackleCore.bmodule)(1),

          dense: {
            labelSelectSpacing: (0, _reactackleCore.bmodule)(1)
          },

          fullWidth: {
            labelSelectSpacing: (0, _reactackleCore.bmodule)(1)
          },

          denseFullWidth: {
            labelSelectSpacing: (0, _reactackleCore.bmodule)(1)
          }
        },
        underlined: {
          labelSelectSpacing: (0, _reactackleCore.bmodule)(1),

          dense: {
            labelSelectSpacing: (0, _reactackleCore.bmodule)(1)
          },

          fullWidth: {
            labelSelectSpacing: (0, _reactackleCore.bmodule)(1)
          },

          denseFullWidth: {
            labelSelectSpacing: (0, _reactackleCore.bmodule)(1)
          }
        }
      },

      breakpoints: [{
        breakpoint: _reactackleCore.breakpointMedium,
        width: 150
      }]
    },

    labelTooltipSpacing: (0, _reactackleCore.bmodule)(1)
  },

  icon: {
    iconTextSpacing: (0, _reactackleCore.bmodule)(0.5),
    element: _react2.default.createElement(_reactackleIcons.IconArrowDropDown, { size: 'custom', color: 'inherit' }),

    state: {
      color: 'inherit',
      opacity: constants.iconInner.opacity,

      disabled: {
        color: 'inherit',
        opacity: 0.35
      },

      focus: {
        color: 'inherit',
        opacity: 1
      },

      error: {
        color: constants.fontColor,
        opacity: constants.iconInner.opacity
      },

      success: {
        color: constants.fontColor,
        opacity: constants.iconInner.opacity
      }
    },

    size: {
      boxSize: function boxSize(base) {
        return constants.size.fontSize(base) * constants.size.lineHeight + constants.size.paddingY(base) * 2;
      },
      imgSize: 30,

      dense: {
        boxSize: function boxSize(base) {
          return constants.size.dense.fontSize(base) * constants.size.dense.lineHeight + constants.size.dense.paddingY(base) * 2;
        },
        imgSize: 26
      },

      fullWidth: {
        boxSize: function boxSize(base) {
          return constants.size.fullWidth.fontSize(base) * constants.size.fullWidth.lineHeight + constants.size.fullWidth.paddingY(base) * 2;
        },
        imgSize: 30
      },

      denseFullWidth: {
        boxSize: function boxSize(base) {
          return constants.size.denseFullWidth.fontSize(base) * constants.size.denseFullWidth.lineHeight + constants.size.denseFullWidth.paddingY(base) * 2;
        },
        imgSize: 30
      }
    }
  },

  message: {
    messageSelectSpacing: (0, _reactackleCore.bmodule)(1),
    fontSize: _reactackleCore.fontSizeSmall,
    lineHeight: 1,

    style: {
      fontColor: _reactackleCore.fontColorMedium,

      disabled: {
        fontColor: _reactackleCore.fontColorMedium
      },

      focus: {
        fontColor: _reactackleCore.fontColorMedium
      },

      error: {
        fontColor: _reactackleCore.colorError
      },

      success: {
        fontColor: _reactackleCore.colorSuccess
      }
    }
  },

  optionsList: {
    borderRadius: _reactackleCore.radiusDefault,
    backgroundColor: _reactackleCore.colorWhite,
    minWidth: '5em',
    maxWidth: '14em',

    size: {
      paddingY: (0, _reactackleCore.bmodule)(1),
      paddingX: 0,

      dense: {
        paddingY: (0, _reactackleCore.bmodule)(1),
        paddingX: 0
      },

      fullWidth: {
        paddingY: (0, _reactackleCore.bmodule)(1),
        paddingX: 0
      },

      denseFullWidth: {
        paddingY: (0, _reactackleCore.bmodule)(1),
        paddingX: 0
      }
    }
  },

  option: {
    size: {
      paddingY: (0, _reactackleCore.bmodule)(1),
      paddingX: (0, _reactackleCore.bmodule)(2),
      lineHeight: constants.size.lineHeight,
      fontSize: constants.size.fontSize,

      dense: {
        paddingY: (0, _reactackleCore.bmodule)(1),
        paddingX: (0, _reactackleCore.bmodule)(2),
        lineHeight: constants.size.lineHeight,
        fontSize: constants.size.dense.fontSize
      },

      fullWidth: {
        paddingY: (0, _reactackleCore.bmodule)(1),
        paddingX: (0, _reactackleCore.bmodule)(2),
        lineHeight: constants.size.lineHeight,
        fontSize: constants.size.fullWidth.fontSize
      },

      denseFullWidth: {
        paddingY: (0, _reactackleCore.bmodule)(1),
        paddingX: (0, _reactackleCore.bmodule)(2),
        lineHeight: constants.size.lineHeight,
        fontSize: constants.size.denseFullWidth.fontSize
      }
    },

    style: {
      fontColor: constants.fontColor,
      backgroundColor: _reactackleCore.colorTransparent,

      hover: {
        fontColor: constants.fontColor,
        backgroundColor: _reactackleCore.colorPaletteGrey100
      },

      focus: {
        fontColor: constants.fontColor,
        backgroundColor: _reactackleCore.colorPaletteGrey100
      },

      disabled: {
        fontColor: _reactackleCore.fontColorMedium,
        backgroundColor: _reactackleCore.colorTransparent
      },

      selected: {
        fontColor: constants.themeColor,
        backgroundColor: _reactackleCore.colorTransparent
      }
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/reactackle-selectbox/dist/styles/theme.js
// module id = 797
// module chunks = 0